import { formatDateTimeInVenueTz } from '../../../../../helpers/formatDateTime';

function convertFieldNameDate(fieldName) {
    // Check if the field name contains an iso datestring
    const isoDateRegex =
        /(?<prefix>.*\()(?<dateString>\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z)(?<endingSlash>\))/;
    const matches = isoDateRegex.exec(fieldName);
    if (matches && matches.groups) {
        const { prefix, dateString, endingSlash } = matches.groups;
        // If it does, convert it to a date object
        const date = new Date(dateString);
        // Format the date to local datetime and join to the prefix
        return `${prefix}${formatDateTimeInVenueTz(date)}${endingSlash}`;
    }
    // If it doesn't, return the field name as is
    return fieldName;
}

export default convertFieldNameDate;
